import { Button, Form, FormProps, Input } from "antd";
import ReactQuill from "react-quill";
import {
  quillToolbarFormats,
  quillToolbarModules,
} from "../../../constants/config";
import SidebarLayout from "../../../layouts/SidebarLayout";

export default function PrivacyPolicy() {
  const onFinish: FormProps<any>["onFinish"] = (values) => {};
  const [form] = Form.useForm();
  return (
    <>
      <SidebarLayout title="Website CMS - Privacy Policy">
        <Form
          name="form_item_path"
          className="custom-form bg-white border border-extra-light border-solid rounded-md"
          layout="vertical"
          onFinish={onFinish}
          requiredMark="optional"
          size="large"
          // form={form}
        >
          <div className="p-6">
            <Form.Item
              name=""
              label="Title"
              rules={[
                {
                  required: true,
                  message: "Please enter title",
                },
              ]}
            >
              <Input size="large" placeholder="Enter title" />
            </Form.Item>
            <Form.Item
              name="email"
              rules={[{ required: true, message: "Please enter description" }]}
            >
              <ReactQuill
                className="h-[400px] mb-11"
                placeholder="Post destruction..."
                theme="snow"
                formats={quillToolbarFormats}
                modules={quillToolbarModules}
              />
            </Form.Item>
            <br />
            <Button type="primary" htmlType="submit">
              Upload & Publish
            </Button>
          </div>
        </Form>
      </SidebarLayout>
    </>
  );
}
